/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class ETransportNotificationVO extends JSONable{

  uuid: string | null = null;
  uit: string | null = null;
  uploadIndex: number | null = null;
  uploadStatus: string | null = null;
  checkStatus: string | null = null;
  anafMessage: string | null = null;

}
